module.exports = __webpack_public_path__ + "static/media/1.9b0635f8.jpg";